
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-1 -1 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--primary-highlight)","stroke":"#4fa2b7","stroke-miterlimit":"10","stroke-width":"4","d":"M37.26 3.77H12.74L.48 25l12.26 21.23h24.52L49.52 25 37.26 3.77z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/polygonFill.svg